import { useState, useEffect, useCallback } from 'react';

interface Props {
  seconds: number;
  running: boolean;
}

interface UseCountDown {
  seconds: number;
  start: (seconds: number) => void;
}

export const useCountDown = ({
  seconds: INITIAL_SECONDS,
  running: INITIAL_RUNNING,
}: Props): UseCountDown => {
  const [seconds, setSeconds] = useState(INITIAL_SECONDS);
  const [running, setRunning] = useState(INITIAL_RUNNING);
  const [id, setId] = useState(0);

  const tick = useCallback(() => {
    running && setSeconds((seconds) => seconds - 1);
    if (seconds === 0) {
      setRunning(false);
      setSeconds(0);
      window.clearInterval(id);
    }
  }, [running, seconds]);

  useEffect(() => {
    const id = window.setInterval(tick, 1000);
    setId(id);
    return () => window.clearInterval(id);
  }, [tick]);

  const start = (seconds: number): void => {
    setRunning(true);
    setSeconds(seconds);
  };

  return { seconds, start };
};
